export default (roles,redirect)=>{  
  return new Promise( (resolve, reject) => {

  	app.store.dispatch('ks_app/counter/increment'); //how to call a vuex store
  	let a = "IsAdmin";
  	roles.forEach(role=>{
  		if(role==a){
  			resolve(true);
  		}
  	})
    reject({path:redirect});
  })
}